import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SICProfessionPackageDTO  {
    _originalTypeClassName = "zERP.BO.SICProfessionPackageDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SICProfessionPackageDTO.translate = translateService;
}
this.Id = null;
this.SICProfessionPackageDTOKey = null;
this._key = this.SICProfessionPackageDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
InsuranceProfessionDTO:any;
InsuranceCoveragePackageDTO:any;
private _SICProfessionPackageDTOKey:any;
get SICProfessionPackageDTOKey(): any {
    return this._SICProfessionPackageDTOKey;
  }
set SICProfessionPackageDTOKey(value: any) {
    this._SICProfessionPackageDTOKey = value;
    this._key = value;
  }
static setInsuranceProfessionDTO = ($this, value) => {
var oldValue = $this.InsuranceProfessionDTO;
$this.InsuranceProfessionDTO = value;
if (value != null) {
}
}
static setInsuranceCoveragePackageDTO = ($this, value) => {
var oldValue = $this.InsuranceCoveragePackageDTO;
$this.InsuranceCoveragePackageDTO = value;
if (value != null) {
}
}

static Assign(spp: any): any{let sppDTO = new Domain.SICProfessionPackageDTO();
sppDTO.Id = spp?.Id;
Domain.SICProfessionPackageDTO.setInsuranceCoveragePackageDTO(sppDTO, Domain.InsuranceCoveragePackageDTO.Assign(spp?.InsuranceCoveragePackage));
Domain.SICProfessionPackageDTO.setInsuranceProfessionDTO(sppDTO, Domain.InsuranceProfessionDTO.Assign(spp?.InsuranceProfession));
return sppDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SICProfessionPackageDTOKey == null || $this.SICProfessionPackageDTOKey == 0;
            }


}